import styled from "styled-components";

export const LoginContainerStyled = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 15px 20px;
  box-sizing: border-box;
  background-image: url(/assets/images/backgrounds/bg_login.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  .logo_show {
    display: flex;
    align-items: center;
    margin-right: 245px;
    .img_logo {
      width: 544px;
      max-width: 100%;
      height: auto;
    }
  }
  .form_layout {
    max-width: 540px;
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.TABLET}) {
    flex-direction: column;
    .logo_show {
      margin-right: 0px;
    }
    .form_layout {
      margin-top: 40px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE}) {
    flex-direction: column;
    .logo_show {
      margin-right: 0px;
      .img_logo {
        width: 432px;
      }
    }
    .form_layout {
      margin-top: 20px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.MOBILE}) {
    flex-direction: column;
    .logo_show {
      margin-right: 0px;
      .img_logo {
        width: 338px;
      }
    }
    .form_layout {
      margin-top: 20px;
      max-width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SMALLMOBILE}) {
    flex-direction: column;
    .logo_show {
      margin-right: 0px;
      .img_logo {
        width: 275px;
      }
    }
    .form_layout {
      margin-top: 20px;
      max-width: 100%;
      padding: 0 12px;
      box-sizing: border-box;
    }
  }
`;
